<div id="airline-tabs" class="container-fluid mt-5">
  <div class="row">
      <div class="col">
      </div>
  </div>
</div>

<router-outlet></router-outlet>
